module.exports = __webpack_public_path__ + "media/order.463563a8.wav";